import { Box } from "@mui/material";
import type { FC } from "react";
import { NEUTRAL } from "../../../theme/tokens";
import { RoleGroupOrJobSelector } from "../../UIToolkit/molecules/RoleGroupOrJobSelector";
import { ShiftTypeFilterChips, type ShiftTypeFilterValue } from "../../UIToolkit/molecules/ShiftTypeFilterChips";
import { originFilterNode } from "../RequestOrigin/originFilterNode";
import { RequestOriginFilter } from "../RequestOrigin/RequestOriginFilter";
import type { OriginFilterState } from "../RequestOrigin/requestOriginMeta";

type Props = {
	selectedRoleGroups: string[];
	onSelectedRoleGroupsChanged: (selected: string[]) => void;
	selectedJobIds: string[];
	onSelectedJobIdsChanged: (selected: string[]) => void;
	selectedShiftType: ShiftTypeFilterValue;
	onSelectedShiftTypeChanged: (next: ShiftTypeFilterValue) => void;
	/** The Origin filter once origins are in, a skeleton while they load, nothing where they are unavailable or failed. */
	originFilter: OriginFilterState;
};

export const RequestsTabFilters: FC<Props> = ({
	selectedRoleGroups,
	onSelectedRoleGroupsChanged,
	selectedJobIds,
	onSelectedJobIdsChanged,
	selectedShiftType,
	onSelectedShiftTypeChanged,
	originFilter,
}) => {
	const origin = originFilterNode(originFilter, (control) => <RequestOriginFilter control={control} />);
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				gap: 1.5,
				p: 1.5,
				mb: 1,
				mx: 1,
				mt: 1,
				flexShrink: 0,
				backgroundColor: NEUTRAL[50],
				borderRadius: 2,
				border: `1px solid ${NEUTRAL[200]}`,
			}}
		>
			<RoleGroupOrJobSelector
				selectedRoleGroups={selectedRoleGroups}
				onSelectedRoleGroupsChanged={onSelectedRoleGroupsChanged}
				selectedJobIds={selectedJobIds}
				onSelectedJobsChanged={onSelectedJobIdsChanged}
			/>
			{origin === null ? (
				<ShiftTypeFilterChips value={selectedShiftType} onChange={onSelectedShiftTypeChanged} dataTestId="requests-shift-type-filter" />
			) : (
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<Box sx={{ flex: 1, minWidth: 0 }}>
						<ShiftTypeFilterChips value={selectedShiftType} onChange={onSelectedShiftTypeChanged} dataTestId="requests-shift-type-filter" />
					</Box>
					{origin}
				</Box>
			)}
		</Box>
	);
};
